
















































































import _ from "lodash";
import Modal from "../core/Modals/Modal.vue";
import { MaterielApi } from "../api/MaterielApi";

export default {
    name: "MaintenanceHsModal",
    components: { Modal },
    props: {
        showModal: Boolean,
    },
    data() {
        return {
            MaterielApi: new MaterielApi(),
            horsService: [],
            enMaintenance: [],
            loading: false,
        };
    },
    computed: {
        total: function () {
            return this.horsService.length + this.enMaintenance.length;
        },
    },
    methods: {
        load: function () {
            let self = this;
            self.loading = true;

            Promise.all([
                self.MaterielApi.getEquipements({
                    etat_operationnel: "broken",
                }),
                self.MaterielApi.getEquipements({
                    etat_operationnel: "maintenance",
                }),
            ])
                .then(function (res) {
                    self.horsService = res[0];
                    self.enMaintenance = res[1];
                    self.loading = false;
                })
                .catch(function (error) {
                    self.loading = false;
                    self.$emit("toast", {
                        message: self.errorMessage(error),
                        kind: "error",
                    });
                });
        },
        errorMessage: function (error) {
            return _.get(
                error,
                "response.data.message",
                "Une erreur est survenue"
            );
        },
        close: function () {
            this.$emit("close-modal");
        },
    },
    watch: {
        showModal: {
            immediate: true,
            handler: function (value) {
                if (value) {
                    this.load();
                }
            },
        },
    },
};
